import React from 'react';
import { useParams } from 'react-router-dom';

import { Helmet } from 'react-helmet-async';

import window from 'window-or-global';

import { __ADMIN__ } from '@vz/env';

import { Content } from '../../components/Content';
import { Preview } from '../../components/MDXEditor/Preview';
import Spinner from '../../components/Spinner';

import { NotFoundPage } from '../lazy';

import { useSWR } from '../../hooks/useSWR';

const spinnerStyle = { top: 'calc(50% - 12px)' };

const Blog = () => {
  const { url } = useParams();
  const {
    data: apiResponse,
    error,
    isLoading
  } = useSWR(`/api/blog/${url}`, {
    initial: window.__INITIAL_DATA__?.[`/api/blog/${url}`]
  });

  const data = apiResponse?.data;

  if (isLoading && !data) {
    return <Spinner size={24} style={spinnerStyle} />;
  }
  if (error && !data) {
    return <NotFoundPage />; // TODO: Error
  }

  if (!data) {
    return <NotFoundPage />; // TODO: NOT FOUND
  }

  return (
    <>
      <Helmet>
        <title>{data.title}</title>
        {data.description && (
          <meta name="description" content={data.description} />
        )}
      </Helmet>
      <section className="w-900">
        <Content data={data}>
          <Preview content={data.content} />
        </Content>
      </section>
    </>
  );
};

export default Blog;
